import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 10"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.74 8.411q.26.287.26.678 0 .39-.26.65a.88.88 0 0 1-.651.261.97.97 0 0 1-.678-.26L5 6.328 1.589 9.74a.94.94 0 0 1-1.303 0A.84.84 0 0 1 0 9.089q0-.39.286-.678L3.672 5 .286 1.589A.93.93 0 0 1 0 .91q0-.39.286-.65a.94.94 0 0 1 1.303 0L5 3.67 8.411.262A.97.97 0 0 1 9.09 0q.39 0 .65.26.261.261.261.651t-.26.678L6.328 5z"
    }, null, -1)
  ]))]))
}
export default { render: render }